import React from "react";
import './style.scss';
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { RootState } from "../../app/store";

import Localized from "../../Localized";
import ButtonAdd from "../ButtonAddCart";
import { Product } from "../../redux/types/Product";

const ProjectResourceCartItem = ({product}) => {

    return (
        <div className="project-resources-cart-item">
            <span className="project-resources-cart-item_title">
                {product.title}
            </span>
            <span className="project-resources-cart-item_description">
                {product.description}
            </span>
            {
                product.items.map((productItem, index) => (
                    <div className="project-resources-cart-item_action">
                        <span className="project-resources-cart-item_action_price">
                            {productItem.amount.toFixed(2)} {productItem.currency}
                        </span>
                        <ButtonAdd id={productItem.id}/>
                    </div>
                ))
            }
            
        </div>
    );
};

export default ProjectResourceCartItem;
